export const SPIRIT = [
  {
    id: "1.",
    title: "우리는 어떤 의견이든 일단 경청합니다."
  },
  {
    id: "2.",
    title: "나인투원에서는 누구나 의견을 이야기할 수 있습니다."
  },
  {
    id: "3.",
    title:
      "우리는 자유롭게 일할 수 있는 회사에서 최고의 퍼포먼스가 나온다고 믿습니다."
  },
  {
    id: "4.",
    title: "우리는 스스로, 열정적으로 경쟁력을 만들어 나갑니다."
  },
  {
    id: "5.",
    title:
      "나인투원의 프로페셔널은 각자의 역할과 자부심으로 서로를 편견없이 존중하는 것입니다."
  },
  {
    id: "6.",
    title: "우리는 세상에 없던 무언가를 만들어내기 위해 즐겁게 일합니다."
  },
  {
    id: "7.",
    title: "우리는 똑똑과 열정 이전에 올바름을 갖춘 사람을 지향합니다."
  },
  {
    id: "8.",
    title: "고민과 토론은 충분히, 결정은 신속히, 실행은 지금 즉시합니다."
  },
  {
    id: "9.",
    title: "우리는 투명한 정보공유가 최선의 의사결정을 만든다고 믿습니다."
  }
];

export const PARTNERS = [
  "molit",
  "mois",
  "seoul",
  "sejong",
  "gimpo",
  "bucheon",
  "jeju",
  "samsung",
  "h-ec",
  "socar",
  "lgcns",
  "ktpowertel"
];

export const NOTICES = [
  {
    title: "간이합병에 따른 채권자 이의제출 및 구주권 제출 공고",
    subtitle: "2025.05.21",
    link: "/notice_view/company_merge",
    target: "_self"
  },
  {
    title: "나인투원 합병에 따른 개인정보 및 위치정보 이전사실 안내 ",
    subtitle: "2024.05.30",
    link: "/notice_view/privacy_policy",
    target: "_self"
  }
];

export const ARTICLES = [
  {
    title: "쏘카 공유전기자전거 3기 가맹사업자 모집",
    subtitle: "헤럴드경제 | 2024.01.15",
    link: "https://news.heraldcorp.com/view.php?ud=20240115000351"
  },
  {
    title: "쏘카 공유 퍼스널 모빌리티 플랫폼 일레클, 3기 가맹사업자 모집",
    subtitle: "매일일보 | 2024.01.12",
    link: "https://www.m-i.kr/news/articleView.html?idxno=1084024"
  },
  {
    title:
      "전기자전거 일레클, 가맹사업자 3기 모집…상반기 가맹 규모 1만 대까지 확대",
    subtitle: "서울경제 | 2024.01.12",
    link: "https://www.sedaily.com/NewsView/2D420IAVKO"
  },
  {
    title: "일레클, 3기 가맹사업자 모집…상반기 가맹 운영대수 1만대로",
    subtitle: "연합뉴스 | 2024.01.12",
    link: "https://www.yna.co.kr/view/AKR20240112024900030?input=1195m"
  },
  {
    title: "'이동의 모든 순간을 연결하라'…쏘카, 스트리밍 모빌리티 고도화",
    subtitle: "이데일리 | 2023.10.31",
    link: "https://www.edaily.co.kr/news/read?newsId=01292326635778496&mediaCodeNo=257&OutLnkChk=Y"
  },
  {
    title: "메이트네트웍스, 속초 이어 강릉으로 전기자전거 '일레클' 서비스 확대",
    subtitle: "에너지경제신문 | 2023.09.08",
    link: "https://www.ekn.kr/web/view.php?key=20230908001049034"
  },
  {
    title: "'일레클' 고성장…쏘카, 연간 흑자 기대감 '솔솔'",
    subtitle: "딜사이트 | 2023.08.21",
    link: "https://dealsite.co.kr/articles/108810"
  },
  {
    title: "“전기자전거로만 110억원”...쏘카 일레클 매출 3배 ‘쑥’",
    subtitle: "매일경제 | 2023.02.18",
    link: "https://www.mk.co.kr/news/business/10650077"
  }
];

export const GA_ID = "UA-144258378-1";
